import * as React from 'react';
import { BaseComponent } from '../../BaseComponent';

import core = egr.wcf.core;
import { PropertyChoice } from './PropertyChoice';

interface PropertyChoiceListProps extends React.Props<PropertyChoiceList> {
    property: core.prop.Property;
    choicelist: Array<core.prop.PropertyValue>;
}

/*
    Child of PropertyItem-Component
    */
export class PropertyChoiceList extends BaseComponent<PropertyChoiceListProps, {}> {
    public render(): JSX.Element {
        const tChoices: Array<JSX.Element> = new Array();
        let customValue: core.prop.PropertyValue | null = this.props.property.getValue();
        for (let i: number = 0; i < this.props.choicelist.length; ++i) {
            if (customValue != null && this.props.property.isValueEqual(this.props.choicelist[i])) {
                customValue = null;
            }
            tChoices.push(
                <PropertyChoice property={this.props.property} choice={this.props.choicelist[i]} key={i}/>
            );
        }
        if (this.props.property.allowCustomChoice) {
            tChoices.push(<PropertyChoice property={this.props.property} choice={null} key="core-property-choice-custom" customValue={customValue}/>);
        }
        return (
            <table className="core-core-property-choices">
                <tbody>{tChoices}</tbody>
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/propertyeditor/PropertyChoiceList.tsx